import React from 'react';
import { TabContent, TabNavItem } from '@src/components/UI/Tabs';

interface Tab {
  id: string;
  title: string;
  contained: boolean;
  content: React.ReactNode;
}

interface InteractiveTabsProps {
  tabs: Tab[];
  activeTab: string;
  setActiveTab: (tabId: string) => void;
}

const InteractiveTabs: React.FC<InteractiveTabsProps> = ({ tabs, activeTab, setActiveTab }) => {
  if (!tabs?.length) {
    return null;
  }

  return (
    <div className="Tabs" style={{ marginTop: 30, width: '100%' }}>
      {/* Only show tab nav if there is more than one tab */}
      {tabs.length > 1 && (
        <div className="nav">
          {tabs.map((tab) => {
            return (
              <TabNavItem
                key={tab.id}
                title={tab.title}
                id={tab.id}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
              />
            );
          })}
        </div>
      )}
      {tabs.map((tab) => {
        return (
          <div
            className={
              tab.contained ? 'container content-section mb-2 pt-0 brainteaser-container' : ''
            }
            key={tab.id}
            style={activeTab === tab.id ? { display: 'block' } : { display: 'none' }}
          >
            <TabContent id={tab.id} activeTab={activeTab}>
              {tab.content}
            </TabContent>
          </div>
        );
      })}
    </div>
  );
};

export default InteractiveTabs;